/**
 * 認証エラー関連の Action
 */
export const AUTH_ERROR_BY_LOGIN_TYPE_REDIRECT = 'AUTH_ERROR_BY_LOGIN_TYPE_REDIRECT';
export const authErrorByLoginTypeRedirect = (isRedirect) => ({
    payload: {
        isRedirectByLoginType: isRedirect,
    },
    type: AUTH_ERROR_BY_LOGIN_TYPE_REDIRECT,
});
